/** @format */

import { useMutation } from "@tanstack/react-query";
import service from "../service/service";

const useSaveMarketOverview = () =>
  useMutation({
    mutationKey: ["saveMarketOverview"],
    mutationFn: marketOvervieData => {
      let api__data = {
        reportDate: marketOvervieData.reportDate,
        productLineId : marketOvervieData.productLineId,
        regionId : marketOvervieData.regionId,
        marketOverviewDTO: {
          title: marketOvervieData.title,
          headerImagePath: marketOvervieData.headerImagePath,
          id: marketOvervieData.id
        },
        marketOverviewDetailDTOS: marketOvervieData.marketOverviewSections.map(data => ({
          title: data.title,
          content: data.content,
          imagePath: data.imagePath
        }))
      }
      return service.saveMarketOverview(api__data)
    },
  });

export default useSaveMarketOverview;
